<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary">
      {{ 'SELLERS.RESET_MFA_DIALOG_TITLE' | translate : { email: getTruncatedEmail() } }}
    </h3>

    <form [formGroup]="reset_mfa_form_group">
      <mat-radio-group
        aria-label="Select an option"
        formControlName="type"
        class="sp-column sp-margin__top-x2 sp-margin__bottom-x2">
        <mat-radio-button [value]="sellers_mfa_type.sms">SMS</mat-radio-button>
        <mat-radio-button [value]="sellers_mfa_type.totp">TOTP</mat-radio-button>
      </mat-radio-group>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="!isFormValid() || is_seller_edit_running"
        [is_spinner_visible]="is_seller_edit_running"
        (click)="onConfirmClick()"></app-shared-button>
    </form>
  </div>
</div>
